var Rm5ExportTableCell, getCellFootnotes, rm5ExportConfig, rm5TbodyCells;

rm5ExportConfig = require('lib/rm5_export_config');

getCellFootnotes = require('lib/rm5export/rm5_export_utils').getCellFootnotes;

rm5TbodyCells = rm5ExportConfig.tbodyCells;

Rm5ExportTableCell = rm5ExportConfig.Rm5ExportTableCell;

module.exports = function(attributes) {
  var cellName, cellNotes, correspondingRiskNotes, formatter, outcomeHasFootnotes, outcomeRow, placeholder, prefix, rowSchema, sofControlNotes, tableType, tableView, _ref;
  tableView = attributes.tableView;
  tableType = "" + tableView + "_regular";
  rowSchema = rm5ExportConfig.theadSchemas[tableType][0];
  outcomeRow = {
    cells: []
  };
  outcomeHasFootnotes = !_(attributes.footnotes).isEmpty();
  for (cellName in rowSchema) {
    placeholder = (_ref = cellName.match(/\[[a-z]+\]/)) != null ? _ref[0] : void 0;
    cellName = cellName.replace(placeholder, '');
    if (cellName === 'absoluteEffect') {
      if (outcomeHasFootnotes) {
        sofControlNotes = getCellFootnotes('contSofControl', attributes.footnotes);
        correspondingRiskNotes = getCellFootnotes('contCorrespondingRisk', attributes.footnotes);
      }
      outcomeRow.cells.push(new Rm5ExportTableCell({
        textContent: rm5TbodyCells['contSofControl'](attributes),
        sup: sofControlNotes || '',
        name: 'contSofControl'
      }));
      switch (tableView) {
        case 'sof':
          outcomeRow.cells.push(new Rm5ExportTableCell({
            textContent: rm5TbodyCells['contRiskDifference'](attributes),
            sup: correspondingRiskNotes || '',
            name: 'contRiskDifference'
          }));
          break;
        case 'sof_accp':
          outcomeRow.cells.push(new Rm5ExportTableCell({
            textContent: rm5TbodyCells['contRiskDifference'](attributes),
            sup: correspondingRiskNotes || '',
            name: 'contRiskDifference'
          }));
          break;
        case 'sof_v3':
        case 'sof_v4':
          outcomeRow.cells.push(new Rm5ExportTableCell({
            textContent: rm5TbodyCells['contCorrespondingRisk'](attributes),
            sup: correspondingRiskNotes || '',
            name: 'contCorrespondingRisk'
          }));
          outcomeRow.cells.push(new Rm5ExportTableCell({
            textContent: rm5TbodyCells['contRiskDifference'](attributes),
            sup: correspondingRiskNotes || '',
            name: 'contRiskDifference'
          }));
      }
    } else if ((cellName === 'sofControl' || cellName === 'correspondingRisk' || cellName === 'riskDifference') && tableView === 'sof_short') {
      prefix = 'cont';
      formatter = prefix + _.string.capitalize(cellName);
      outcomeRow.cells.push(new Rm5ExportTableCell({
        textContent: rm5TbodyCells[formatter](attributes),
        sup: sofControlNotes || '',
        name: formatter
      }));
    } else {
      if (outcomeHasFootnotes) {
        cellNotes = getCellFootnotes(cellName, attributes.footnotes);
      }
      outcomeRow.cells.push(new Rm5ExportTableCell({
        textContent: rm5TbodyCells[cellName](attributes),
        sup: cellNotes || '',
        name: cellName
      }));
    }
  }
  return outcomeRow;
};
